import { View } from 'react-native';
import useStyle from '../../hooks/useStyle';
import { useMemo } from 'react';
import { rotationMap, staticStyle } from './Triangle.content';
import { TriangleProps } from './Triangle.types';

function Triangle({ backgroundColor, size, direction }: TriangleProps) {
  const style = useStyle({ backgroundColor });

  const computedStyle = useMemo(
    () => ({
      ...staticStyle,
      borderLeftWidth: size / 2,
      borderRightWidth: size / 2,
      borderBottomWidth: size,
      borderBottomColor: style.backgroundColor,
      transform: `rotate(${rotationMap[direction]}deg)`,
    }),
    [style, size, direction],
  );

  return <View style={computedStyle} />;
}

export default Triangle;
